import ContactForm from "../../components/ContactForm";
import Section from "../../components/Section";
import SectionLayout from "../../components/[przyjaznedeklaracje]/_sectionLayout";
import DeclarationBox from "../../components/DeclarationBox";
import DeclarationBoxItem from "../../components/DeclarationBoxItem";
import DeclarationModal from "../../components/DeclarationModal";

import Variables from "../../variables/variables.json";
import BackButton from "../../components/BackButton";

import Nieruchomosci from "../../content/przyjaznedeklaracje/podatek-od-nieruchomosci/section-1_pl.mdx";
import DeclarationBoxIndividual from "../../components/DeclarationBoxIndividual";
import BackgroundSection from "../../components/BackgroundSection";
import SectionBox from "../../components/SectionBox";
import CustomListWithZero from "../../components/CustomListWithZero";
import FAQ from "../../components/FAQ";

import Transportowe1 from "../../content/przyjaznedeklaracje/podatek-od-srodkow-transportowych/section-1_pl.mdx";
import Transportowe2 from "../../content/przyjaznedeklaracje/podatek-od-srodkow-transportowych/section-2_pl.mdx";
import Transportowe3 from "../../content/przyjaznedeklaracje/podatek-od-srodkow-transportowych/section-3_pl.mdx";
import Transportowe4 from "../../content/przyjaznedeklaracje/podatek-od-srodkow-transportowych/section-4_pl.mdx";
import Transportowe5 from "../../content/przyjaznedeklaracje/podatek-od-srodkow-transportowych/section-5_pl.mdx";
import Transportowe6 from "../../content/przyjaznedeklaracje/podatek-od-srodkow-transportowych/section-6_pl.mdx";

export default function PodatekOdSrodkowTransportowych(props) {
	let Miasto = "PRZYJAZNEDEKLARACJE";
	let Podatek = "transportowe";

	return (
		<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="slider" breadcrumbsLayout="light">
			<Section mdx>
				<Transportowe1 />
			</Section>

			<Section mdx lighterdark noPanel>
				<Transportowe2 />
			</Section>

			<Section mdx>
				<Transportowe3 />
			</Section>

			<BackgroundSection
				miasto={Miasto}
				section="transportowe"
				attachment
				textAlign="left"
				button="primary"
				title
				subtitle
				bgColor="shadow"
			/>

			<Section mdx>
				<Transportowe4 />
			</Section>

			<Section mdx lighterdark>
				<Transportowe5 />

				<CustomListWithZero miasto={Miasto} section="transportowe" />
			</Section>

			<BackgroundSection
				miasto={Miasto}
				section="transportowe"
				attachment
				textAlign="left"
				button="primary"
				title
				subtitle
				bgColor="shadow"
			/>

			<Section title="sections.czestozadawanepytania.title">
				<FAQ miasto={Miasto} section="transportowe" secondary />
			</Section>

			<Section
				id="wypelnij-deklaracje"
				title="sections.wypelnijdeklaracjedt1.title"
				lightdark
				titleLeft
			>
				<DeclarationBoxIndividual podatek="dt1new" noReadMore btnPrimary button="link" />
			</Section>

			<Section lightdark>
				<BackButton />
			</Section>

			<DeclarationModal miasto={Miasto} podatek={Podatek} />
		</SectionLayout>
	);
}
